import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { formatMoney } from '../../utils/format';

export function SellConfirmation({ vehicle, sellPrice, onConfirm, onCancel, t }) {
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" data-testid="sell-confirm-overlay">
      <div className="bg-ink-800 rounded-xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className="bg-red-600 px-5 py-4">
          <h3 className="text-foreground font-bold text-lg">{t('sell_confirm_title')}</h3>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-slate-300">
            {t('sell_confirm_text')} <strong>{vehicle.brand} {vehicle.model}</strong>.
          </p>
          <div className="bg-ink-700/30 rounded-lg p-3 text-center">
            <p className="text-xs text-slate-500">{t('estimated_resale')}</p>
            <p className="text-2xl font-bold text-money">{formatMoney(sellPrice)}</p>
            <p className="text-[10px] text-slate-500 mt-1">
              ({Math.round(sellPrice / vehicle.price * 100)}% {t('of_new_price')} {formatMoney(vehicle.price)})
            </p>
          </div>
          {vehicle.assignedDriverId && (
            <p className="text-xs text-warn bg-warn/10 rounded px-2 py-1 flex items-center gap-1">
              <AlertTriangle className="w-3 h-3" /> {t('driver_released')}
            </p>
          )}
        </div>
        <div className="px-5 py-4 border-t border-ink-600 flex gap-3 justify-end">
          <button onClick={onCancel} className="text-sm text-slate-500 px-4 py-2 hover:text-slate-300" data-testid="cancel-sell-btn">
            {t('cancel')}
          </button>
          <button onClick={onConfirm} className="bg-red-600 text-white px-5 py-2 rounded-lg text-sm font-bold hover:bg-red-700 transition-colors" data-testid="confirm-sell-btn">
            {t('sell_vehicle')}
          </button>
        </div>
      </div>
    </div>
  );
}
